export const environment = {
	production: false,
	baseURL: 'https://api.dev.behyve.net/api/v1',
	googlApi: 'AIzaSyCdeS341f0DuePMSehSR9XEqf0EEEyePac',
	impersonationEncryptionKey: '097676dea23439fa1059a0f42469aa614fe6ec2d13248adec5a43c65e00c1310',
};